import type { IDependentControl } from '../../type';

import { EOperatorField, EFilterField } from '~/core/gemxql/types';

export { EOperatorField, EFilterField };

export enum EReportControlId {
  //Filter
  METRICS_FILTER = 'metricsFilter',
  DIMENSIONS_FILTER = 'dimensionsFilter',
  CHART_FILTER = 'chartFilter',
  COLUMN_FILTER = 'columnFilter',
  FILTER = 'filter',
  // Metrics
  METRIC = 'metric',

  // Chart
  CHART = 'chart',

  // Column
  COLUMN = 'column',

  //Device
  DEVICE = EFilterField.DEVICE,
  DEVICES = EFilterField.DEVICES,

  //Visitor
  VISITOR = EFilterField.VISITOR,
  VISITORS = EFilterField.VISITORS,

  //Traffic Source
  TRAFFIC_SOURCE = EFilterField.TRAFFIC_SOURCE,
  TRAFFIC_SOURCES = EFilterField.TRAFFIC_SOURCES,

  //Version
  VERSION = EFilterField.VERSION,
  VERSIONS = EFilterField.VERSIONS,

  //Page
  SINGLE_PAGE = EFilterField.SINGLE_PAGE,
  LIST_PAGE = EFilterField.LIST_PAGE,

  //Campaign
  TAB_CAMPAIGN = 'tabCampaign',
  SINGLE_CAMPAIGN = EFilterField.SINGLE_CAMPAIGN,
  GROUP_CAMPAIGN = EFilterField.GROUP_CAMPAIGN,
  PRICE_CAMPAIGN = EFilterField.PRICE_CAMPAIGN,
  URL_CAMPAIGN = EFilterField.URL_CAMPAIGN,

  //Campaign Template
  FILTER_GROUP_CAMPAIGN_ITEM = 'filterGroupCampaignItem',
  GROUP_CAMPAIGN_ITEM = EFilterField.GROUP_CAMPAIGN_ITEM,
  GROUP_CAMPAIGN_ITEMS = EFilterField.GROUP_CAMPAIGN_ITEMS,

  //Operator
  DEVICE_OPERATOR = EOperatorField.DEVICE_OPERATOR,
  VISITOR_OPERATOR = EOperatorField.VISITOR_OPERATOR,
  TRAFFIC_SOURCE_OPERATOR = EOperatorField.TRAFFIC_SOURCE_OPERATOR,
  VERSION_OPERATOR = EOperatorField.VERSION_OPERATOR,
  PAGE_OPERATOR = EOperatorField.PAGE_OPERATOR,
  CAMPAIGN_ITEM_OPERATOR = EOperatorField.CAMPAIGN_ITEM_OPERATOR,
}

export interface IRItemCard {
  title: string;
  content: string;
  dependentControls?: IDependentControl[];
  formula?: React.ReactNode;
  helps: string[];
}

export type IRItemInfo = Record<string, IRItemCard>;

export enum EControlSettingType {
  REPORT = 'report',
  ORDER = 'order',
}
